import {useState, useEffect} from "react";

function useLocalStorage(key, newValue) {
    let initialValue = newValue ? newValue : window.localStorage.getItem(key)
    let [localStorage, setLocalStorage] = useState(initialValue || '')

    useEffect(() => {
        window.localStorage.setItem(key, localStorage)
    }, [key,localStorage]);

    return [localStorage, setLocalStorage];
}

export default useLocalStorage;